import { makeStyles, Snackbar } from '@material-ui/core';
import Button from 'bz-core-controls/controls/general/button';
import useInterval from 'lib/hooks/useInterval';
import React from 'react';

const VersionCheck = () => {
  const [open, setOpen] = React.useState(false);
  const currentVersion = `${process.env.Version ?? ''}`.trim();

  const isValidVersion = (version: string) => {
    if (!version) return false;
    const normalised = version.trim().toLowerCase();
    // Reject sentinel values produced by local dev builds (both esbuild and
    // rsbuild fall back to 'local-dev' when no CI env vars are present).
    return normalised !== '0' && normalised !== 'local-dev' && !normalised.includes('undefined');
  };

  useInterval(async () => {
    // Version polling is only meaningful for deployed builds with a real version
    // string. isValidVersion rejects the 'local-dev' sentinel used by both
    // esbuild (NODE_ENV=test) and rsbuild local builds, so no NODE_ENV guard
    // is needed here.
    if (!isValidVersion(currentVersion)) return;

    try {
      const res = await fetch('/version.json', { cache: 'reload' });
      if (!res.ok) return;

      const data = await res.json();
      const remoteVersion = `${data?.Version ?? ''}`.trim();
      if (!isValidVersion(remoteVersion)) return;

      if (remoteVersion !== currentVersion) {
        setOpen(true);
      }
    } catch {
      // Ignore transient fetch/parse issues; avoid false update prompts.
    }
  }, 60000);

  return <Snackbar open={open} message={<SnackContent version={process.env.Version} />} />;
};

const useStyles = makeStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridColumnGap: '1em',
    alignItems: 'center'
  }
});

const SnackContent = (): JSX.Element => {
  const classes = useStyles();

  const onClick = () => {
    window.location.reload();
  };

  return (
    <div className={classes.container}>
      <span>New version available</span>
      <Button primary={true} onClick={() => onClick()}>
        Refresh Page
      </Button>
    </div>
  );
};

export default VersionCheck;
